// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { IEnvironment } from "src/app/shared/interfaces/environment.interface";

export const environment: IEnvironment = {
  production: false,
  apiUrl: '/api', // New in-house authentication API
  Issuer: 'https://auth.egishe.bg', // DEPRECATED - kept for backward compatibility
  /*Issuer: 'https://localhost:61895',*/
  ClientId: 'com.wetrack.frontend.spa.client', // DEPRECATED - kept for backward compatibility
  MOBILE_APP_ID: 'com.wetrack.stage',
  DOMAIN: 'localhost:4200',
  BackEndApi: 'http://app.egishe.bg/',
  epayUrl: 'https://www.epay.bg/',
  easyPayMurchId: '2001418',
  easyPaySecret: 'HnqSeZzN4mw25CGVDdpLvfPAYt36Txgu',
  mpostSid: '000000000000010',
  mpostWalletNumber: '61938166610',
  mapProvider: 'com.google.maps',
  google_maps: {
    key: 'AIzaSyBY_2ESX8FkkXjGFcQUWIGFraEyCqy4w4s',
    version: 'weekly',
    map_id: 'b38743b63c162646',
    default_location: {
      lat: 42.5,
      lng: 23.5
    }
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
